import * as React from "react";

import { cn } from "@/lib/utils";

// Textarea — matches Input's border, radius, and focus-state grammar so
// they line up visually in shared forms.
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "field-sizing-content flex min-h-24 w-full resize-y rounded-xl border border-border bg-background px-3.5 py-2.5 text-[14px] leading-[1.55] text-foreground shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] transition-[border-color,box-shadow] duration-150 outline-none",
        "placeholder:text-muted-foreground",
        "focus-visible:border-foreground/40 focus-visible:ring-2 focus-visible:ring-ring/40",
        "disabled:cursor-not-allowed disabled:bg-muted/60 disabled:opacity-60",
        "aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/30",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
